import React from "react";
import "../styles/style.css"; // change later
import { FaEnvelope, FaInstagram, FaLinkedin } from "react-icons/fa";

const About = () => {
  return (
    <div className="page-container">
      <main>
        <div className="about-project">
          <div className="about-project-text">
            <h2>About Impact Afghanistan</h2>
            <p className="description about-status">
              <strong className="about-status-label">Status:</strong>{" "}
              <span className="about-status-value">Ongoing</span>
            </p>
            <p className="description">
              <strong>Impact Afghanistan at Brown University</strong>{" "}
              is a project developed to ensure Afghanistan remains at the
              forefront of policy and research agendas. The project features an
              online platform that curates publications on Afghanistan post-2021
              and invites scholars and students to submit articles for inclusion
              in the database.
            </p>
            <p className="description">
              The project also aims to identify gaps in reporting on Afghanistan
              and undertakes studies in collaboration with civil society
              partners. Aligned to the United Nations' Summit of the Future and
              its Outcomes, Impact Afghanistan serves as a model for future
              efforts to maintain a lens on contexts where information is
              limited.
            </p>
            <p className="description">
              The Impact Afghanistan project is grateful for support from Brown
              University's Khosrowshahi University Professor of Computer
              Science, Ugur Çetintemel, the Karen T. Romer, SPRINT|UTRAs, and
              staff of the Brown University libraries. Brown students, faculty,
              staff and alumni have been engaged with this project since 2024.
            </p>
            <p className="description">
              In 2025, students from Middlebury College and Trinity College (CT)
              joined the team.
            </p>
            <p className="description">
              The project has initiated a collaboration with{" "}
              <a href="https://womenforafghanwomen.org/">
                Women for Afghan Women
              </a>
              {" "}
              (WAW). WAW is a grassroots organization dedicated to
              protecting and promoting the rights of Afghan women, girls, and
              families. With community centers in New York and Virginia, and a
              strong foundation of work across Afghanistan, WAW provides direct
              services, including case management, legal support, counseling,
              educational programs, and youth leadership initiatives, rooted in
              cultural competence and gender equality. Through advocacy,
              education, and empowerment, WAW works to ensure that Afghan women
              and girls can rebuild their lives with dignity and lead change in
              their communities.
            </p>
          </div>
        </div>

        <div className="team-section">
          <div className="team-section-text">
            <h2>Project Leads</h2>
            <div className="team-grid">
              <div className="team-member">
                <h3 className="member-name">Ugur Cetintemel</h3>
                <p className="member-org">
                  Khosrowshahi University Professor of Computer Science, Brown
                  University
                </p>
                <p className="member-bio"></p>
                <div className="member-links">
                  <a href="mailto:ugur_cetintemel@brown.edu">
                    ugur_cetintemel@brown.edu
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Kathryn Good</h3>
                <p className="member-org">
                  Head, Civil Society & NGLS at the United Nations
                </p>
                <p className="member-bio"></p>
                <div className="member-links">
                  <a href="mailto:kathryn_good@brown.edu">
                    kathryn_good@brown.edu
                  </a>
                  <a href="www.linkedin.com/in/kathryn-good">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Nilab Ibrahimy</h3>
                <p className="member-org">Brown University</p>
                <p className="member-bio">
                  Nilab Ibrahimy is an education advocate advancing learning
                  opportunities for women and girls. With degrees from Brown
                  University and the AUW, she combines policy expertise with
                  hands-on leadership in programs supporting Afghan women's
                  education, leadership, and community engagement.
                </p>
                <div className="member-links">
                  <a href="mailto:nilabibra@gmail.com">nilabibra@gmail.com</a>
                  <a href="www.linkedin.com/in/nilab-ibrahimy">
                    LinkedIn Profile
                  </a>
                </div>
              </div>
            </div>

            <h2 className="team-title">Team</h2>
            <div className="team-grid">
              <div className="team-member">
                <h3 className="member-name">Maja Mishevska</h3>
                <p className="member-org">Brown University · 2026</p>
                <p className="member-bio">
                  {" "}
                  Maja Mishevska is a junior at Brown University studying
                  Computer Science and Gender and Sexuality Studies. She is
                  passionate about human-computer interaction and
                  public-interest technology, with experience building
                  full-stack applications and low-resource language models.
                </p>
                <div className="member-links">
                  <a href="mailto:maja_mishevska@brown.edu">
                    maja_mishevska@brown.edu
                  </a>
                  <a href="https://www.linkedin.com/in/maja-mishevska/">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Ayda Haydarpour</h3>
                <p className="member-org">WAW Intern · 2026</p>
                <p className="member-bio">
                  Ayda Haydarpour is a fourth-year Computer Science student at
                  Virginia Tech with experience in AWS, Consulting, and
                  educational technology. She is passionate about using
                  technology to empower underserved communities.
                </p>
                <div className="member-links">
                  <a href="mailto:aydahaydarpour@gmail.com">
                    aydahaydarpour@gmail.com
                  </a>
                  <a href="https://www.linkedin.com/in/ayda-haydarpour-/">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Henry Greenhut</h3>
                <p className="member-org">Brown University · 2025</p>
                <p className="member-bio">
                  {/* Hi! I'm a sophomore at Brown studying Computer Science and
                  Physics. I'm passionate about building technology for social
                  good, with experience building apps, websites, and software
                  infrastructure for nonprofits. */}
                  Henry Greenhut is a sophomore at Brown studying Computer
                  Science and Physics. He is passionate about building
                  technology for social good, with experience building apps,
                  websites, and software infrastructure for nonprofits.
                </p>
                <div className="member-links">
                  <a href="mailto:henry_greenhut@brown.edu">
                    henry_greenhut@brown.edu
                  </a>
                  <a href="https://www.linkedin.com/in/henry-greenhut/">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Aarav Kumar</h3>
                <p className="member-org">Brown University · 2025</p>
                <p className="member-bio">
                  {/* I am a junior at Brown studying Applied Math - Computer
                  Science. I am deeply interested in building software to
                  support social impact initiatives, with a focus on building
                  accessible systems that are intuitive for diverse users. */}
                  Aarav Kumar is a junior at Brown studying Applied Math -
                  Computer Science. He is deeply interested in building software
                  to support social impact initiatives, with a focus on building
                  accessible systems that are intuitive for diverse users.
                </p>
                <div className="member-links">
                  <a href="mailto:aarav_kumar@brown.edu">
                    aarav_kumar@brown.edu
                  </a>
                  <a href="https://www.linkedin.com/in/aarav-kumar-657922283/">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Inara Sadiqi</h3>
                <p className="member-org">Trinity College · 2025</p>
                <p className="member-bio">
                  Inara Sadiqi is a Public Policy and Law student at Trinity
                  college with experience across legal work and multilingual
                  communication. She is committed to bridging policy and lived
                  experience to advocate for communities often left out of the
                  conversation.
                </p>
                <div className="member-links">
                  <a href="mailto:isadiqi@trincoll.edu">isadiqi@trincoll.edu</a>
                  <a href="https://www.linkedin.com/in/inara-sadiqi-a9b891320/">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Samimah Naiemi</h3>
                <p className="member-org">Middlebury College · Summer 2025</p>
                <p className="member-bio">
                  Samimah Naiemi is a Political Science student at Middlebury
                  College, passionate about human rights, women's advocacy, and
                  immigrant justice. Originally from Afghanistan, she has
                  published articles highlighting the struggles of immigrants
                  and the realities of life in exile.
                </p>
                <div className="member-links">
                  <a href="mailto:snaiemi@middlebury.edu">
                    snaiemi@middlebury.edu
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Kathy Li</h3>
                <p className="member-org">Brown University · 2024–25</p>
                <p className="member-bio">
                  {/* Hi! I'm a junior at Brown University studying Computer Science
                  and Science, Technology, and Society. I worked on this amazing
                  project from May 2024 - May 2025, doing mostly frontend
                  development! */}
                  Kathy Li is a junior at Brown University studying Computer
                  Science and Science, Technology, and Society. She worked on
                  this amazing project from May 2024 - May 2025, doing mostly
                  frontend development!
                </p>
                <div className="member-links">
                  <a href="mailto:kathyli.2305@gmail.com">
                    kathyli.2305@gmail.com
                  </a>
                  <a href="https://linkedin.com/in/kathymli">
                    LinkedIn Profile
                  </a>
                </div>
              </div>

              <div className="team-member">
                <h3 className="member-name">Yifan Zhang</h3>
                <p className="member-org">Brown University · 2024–25</p>
                <p className="member-bio">
                  {/* Hi! I am a recent Computer Science graduate from Brown and a
                  developer on the team between Summer 2024 and Spring 2025. I
                  mainly worked on backend development and data processing. */}
                  Yifan Zhang is a recent Computer Science graduate from Brown
                  and a developer on the team between Summer 2024 and Spring
                  2025. She mainly worked on backend development and data
                  processing.
                </p>
                <div className="member-links">
                  <a href="mailto:yifan_zhang4@alumni.brown.edu">
                    yifan_zhang4@alumni.brown.edu
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="un-summit">
          <div className="un-summit-text">
            <h2>Alignment with the UN Summit of the Future</h2>

            <p>
              Developed in parallel with the preparatory process for the United
              Nations <em>Summit of the Future</em>, this project aligns closely
              with the Summit's core outcomes. It engages directly with the{" "}
              <em>Pact for the Future</em>, the{" "}
              <em>Declaration on Future Generations</em>, and the{" "}
              <em>Global Digital Compact</em>, integrating their principles into
              our structure, priorities, and methodologies.
            </p>

            <details className="un-item">
              <summary>Pact for the Future</summary>
              <p>
                The <strong>Pact for the Future</strong> advocates for a
                reformed multilateral system that addresses contemporary global
                challenges and delivers equitable outcomes for all. It
                emphasizes the mainstreaming of gender and human rights across
                five thematic pillars:
              </p>

              <ol className="un-list roman">
                <li>Sustainable development and financing</li>
                <li>International peace and security</li>
                <li>
                  Science, technology, and innovation (STI) and digital
                  cooperation
                </li>
                <li>Youth and future generations</li>
                <li>The transformation of global governance</li>
              </ol>

              <p>
                The Impact Afghanistan database is thematically organized to
                reflect and support these five pillars, offering curated and
                verified data aligned with each chapter of the Pact.
              </p>
            </details>

            <details className="un-item">
              <summary>Declaration on Future Generations</summary>
              <p>
                The <strong>Declaration on Future Generations</strong>{" "}
                underscores the imperative of youth participation in global
                decision-making processes and calls for institutional mechanisms
                that ensure their voices are heard across all UN
                intergovernmental fora. It also establishes a global standard
                for meaningful youth engagement and advocates for
                future-oriented governance that actively seeks to avoid
                foreseeable harm to coming generations. This project, being
                youth-led and maintained, aligns with these goals by examining
                the long-term implications of Taliban rule and documenting the
                lived realities of Afghans within and beyond the country. It
                operates on the premise that access to accurate information can
                mitigate future harm and preserve collective memory for future
                generations.
              </p>
            </details>

            <details className="un-item">
              <summary>Global Digital Compact</summary>
              <p>
                The Global Digital Compact seeks to leverage digital
                technologies for inclusive development while addressing
                associated risks. Its priorities include:
              </p>

              <ol className="un-list roman">
                <li>
                  Bridging digital divides and accelerating progress on the
                  Sustainable Development Goals (SDGs);{" "}
                </li>
                <li>
                  Promoting inclusive participation in the digital economy;
                </li>
                <li>Ensuring open, safe, and secure digital environments; </li>
                <li>Advancing data governance frameworks;</li>
                <li>
                  Enhancing oversight of emerging technologies such as
                  artificial intelligence.{" "}
                </li>
              </ol>

              <p>
                In alignment with these aims, <em>Impact Afghanistan</em>{" "}
                employs digital tools and methodologies to manage data
                responsibly, expand digital inclusion, and support open access
                to information in contexts where such access is often
                constrained.
              </p>
            </details>

            <p>
              A core component of the project is its integration into{" "}
              <b>undergraduate teaching and learning</b>. Under faculty
              supervision, students engage in data management and analysis,
              acquiring research skills while contributing to a real-world
              project operating under resource-constrained and politically
              sensitive conditions. The project addresses challenges related to
              limited computing capacity and data availability by developing
              systems for identifying, curating, and sustaining relevant data
              streams through adaptive and increasingly self-managing processes.
            </p>

            <p className="cta">
              See the presentation of the project at the{" "}
              <a
                href="https://powerinhervoicereimaginingagen.splashthat.com/"
                target="_blank"
                rel="noreferrer"
              >
                UN Summit of the Future Action Days
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      <footer className="footer">
        <div className="copy">
          &copy; 2024&ndash;{new Date().getFullYear()} Impact Afghanistan - All Rights Reserved.
        </div>
        <div className="bottom-links">
          <div className="links">
            <a href="mailto:impactcompact.afghanistan@gmail.com">
              <FaEnvelope /> impactcompact.afghanistan@gmail.com
            </a>
            <a
              className="icon-link"
              href="https://www.linkedin.com/in/impactafghanistan/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              className="icon-link"
              href="https://www.instagram.com/impactafghanistan1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;
